export default class PurchaseRecapActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static DETAIL_DATA = 'DETAIL_DATA';
    static CONVERT_PR = 'CONVERT_PR';
    static GET_HELPER_PURCHASERECAP ='GET_HELPER_PURCHASERECAP';
    static GET_HELPER_OFFERING ='GET_HELPER_OFFERING';
    static GET_HELPER_PURCHASERECAP_FULL ='GET_HELPER_PURCHASERECAP_FULL';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';

    static submit(){
      return {
        type: PurchaseRecapActions.ON_SUBMIT
      };
    }
    static convert() {
      return {
        type: PurchaseRecapActions.CONVERT_PR
      };
    }
    static create(data) {
      return {
        type: PurchaseRecapActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: PurchaseRecapActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: PurchaseRecapActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: PurchaseRecapActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: PurchaseRecapActions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: PurchaseRecapActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: PurchaseRecapActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: PurchaseRecapActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: PurchaseRecapActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: PurchaseRecapActions.GET_HELPER_PURCHASERECAP,
        payload:data
      };
    }
    static helperFull(data){
        return {
          type: PurchaseRecapActions.GET_HELPER_PURCHASERECAP_FULL,
          payload:data
        };
      }
    static helperOff(data){
        return {
          type: PurchaseRecapActions.GET_HELPER_OFFERING,
          payload:data
        };
      }
      static detail(data){
        return {
          type: PurchaseRecapActions.DETAIL_DATA,
          payload:data
        };
      }
      static resetList(){
        return {
          type: PurchaseRecapActions.RESET_LIST,
        };
      }
  }